export default {
      id: "alert-usage",
      viewBox: "0 0 68 68",
      url: __webpack_public_path__ + "img/icons.95404f0a.svg#alert",
      toString: function () {
        return this.url;
      }
    }